import { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function TaskReminder({ language }) {
    const [urgentTasks, setUrgentTasks] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/api/tasks`);
                const tasks = Array.isArray(res.data) ? res.data : [];
                const today = new Date();
                today.setHours(0,0,0,0);
                
                const urgent = tasks.filter(t => !t.completed && t.due_date).map(t => {
                    const due = new Date(t.due_date);
                    due.setHours(0,0,0,0);
                    return { ...t, diffDays: Math.ceil((due - today) / (1000*60*60*24)) };
                }).filter(t => t.diffDays <= 2).sort((a,b) => a.diffDays - b.diffDays);
                
                setUrgentTasks(urgent);
            } catch(e) {}
        })();
    }, []);

    if (urgentTasks.length === 0) return null;

    return (
        <Link to="/tasks">
            <Card className="border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/20 border">
                <CardContent className="p-3">
                    <p className="text-[10px] font-semibold text-amber-700 dark:text-amber-300 flex items-center gap-1 mb-1">
                        <AlertCircle className="w-3 h-3" />
                        {language === 'de' ? 'Aufgaben-Erinnerung' : 'Task Reminder'}
                    </p>
                    {urgentTasks.slice(0, 3).map(t => (
                        <p key={t.id} className="text-xs flex items-center gap-1.5 py-0.5">
                            <span>{t.diffDays < 0 ? '🔴' : t.diffDays === 0 ? '🟡' : '🟢'}</span>
                            <span className="truncate flex-1">{t.title}</span>
                            <span className="text-[10px] text-muted-foreground shrink-0">
                                {t.diffDays < 0 ? `${Math.abs(t.diffDays)}T überfällig` : t.diffDays === 0 ? 'Heute' : `In ${t.diffDays}T`}
                            </span>
                        </p>
                    ))}
                </CardContent>
            </Card>
        </Link>
    );
}
